import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { WebSocketService } from './web-socket.service';

export interface AuthData{
  lane: number;
  message: string[];
}

@Injectable({
  providedIn: 'root',
})
export class AuthDataService {
  private _authDataSubscription: Subscription;

  private $authData: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(private wsService: WebSocketService) {
    this._authDataSubscription = this.wsService.listen('authData').subscribe((message: AuthData) => {
      if (message == null) {
        return;
      }
      if (typeof message === 'string') {
        message = JSON.parse(message);
      }
      if (Array.isArray(message)) {
        message.forEach(processAuthData);
      } else {
        processAuthData(message);
      }
    });

    const processAuthData = (authData: AuthData) => {
      if (authData == null) {
        return;
      }
      const actualData = this.$authData.getValue();
      if (actualData[authData.lane] == null) {
        actualData[authData.lane] = authData.message;
      }
      actualData[authData.lane] = authData.message;
      this.$authData.next(actualData);
    };

    console.log('Auth data guardada en authDataService', this.$authData);
  }

  OnDestroy() {
    this._authDataSubscription.unsubscribe();
  }

  getAuthData(laneId) {
    return this.$authData.asObservable().pipe(
      map((authData) => authData[laneId]),
      distinctUntilChanged()
    );
  }

  getCurrentAuthData = (laneId: number) => {
    console.log('AuthDataService:  Solicitando estado actual de Auth Data...');
    this.wsService.send("getAuthData", { laneId });
  };
}